import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldX, Home, ArrowLeft } from "lucide-react";

export default function Forbidden() {
  useEffect(() => {
    document.title = "Adgang nægtet - Carinas Køreskole";
  }, []);

  return (
    <div className="bg-brand-light min-h-[calc(100vh-80px)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-3xl border border-stone-200 shadow-xl">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-amber-50 text-amber-600 border border-amber-100">
          <ShieldX className="h-8 w-8" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-black text-brand-dark tracking-tight">403 - Adgang nægtet</h1>
          <p className="text-stone-500 text-sm leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side eller ressource.
          </p>
        </div>
        <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="px-5 py-3 bg-brand-primary text-white text-sm font-bold rounded-xl shadow hover:bg-brand-primary-hover transition-all duration-200 flex items-center justify-center gap-2"
          >
            <Home className="h-4 w-4" />
            Gå til Forsiden
          </Link>
          <button
            onClick={() => window.history.back()}
            className="px-5 py-3 bg-stone-50 text-brand-dark border border-stone-200 text-sm font-bold rounded-xl hover:bg-stone-100 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Gå tilbage
          </button>
        </div>
      </div>
    </div>
  );
}
